import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ForgotPasswordCredentials } from '@pages/login-recovery-options/models/forgot-password-credentials.interface';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import {
  InputComponent,
  inputValidators,
  LargeButtonComponent,
  LinkComponent,
  userNameValidators,
  PrefetchLinkDirective,
} from '@kaseya-design-components';
import { TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { LoginRecoveryPath } from '@pages/login-recovery-options/routes/login-recovery-path.enum';

@Component({
  selector: 'itc-recover-password',
  templateUrl: 'recover-password.component.html',
  styleUrl: 'recover-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent, LargeButtonComponent, LinkComponent, TranslatePipe, RouterLink, PrefetchLinkDirective],
})
export class RecoverPasswordComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);

  readonly organizationName = input<string>();
  readonly username = input<string>();
  readonly loading = this.loginRecoveryFacade.loading;
  readonly recoveryForm = new FormGroup({
    username: new FormControl('', {
      nonNullable: true,
      validators: userNameValidators,
    }),
    companyName: new FormControl('', {
      nonNullable: true,
      validators: [inputValidators.required, inputValidators.notEmptyOrWhiteSpaces],
    }),
  });
  readonly ApplicationPath = ApplicationPath;
  readonly LoginRecoveryPath = LoginRecoveryPath;

  ngOnInit(): void {
    this.prefillRecoveryForm();
    this.clearQueryParams();
  }

  recoverCredentials(): void {
    this.loginRecoveryFacade.recoverCredentialsByPassword(this.recoveryForm.value as ForgotPasswordCredentials);
  }

  backToLogin(): void {
    this.router.navigateByUrl(ApplicationPath.Login);
  }

  private prefillRecoveryForm(): void {
    this.recoveryForm.patchValue({
      companyName: this.organizationName() ?? '',
      username: this.username() ?? '',
    });
  }

  private clearQueryParams(): void {
    this.router.navigate([], { relativeTo: this.activatedRoute });
  }
}
